import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const auroraCliffsMetadata = {
  id: 'aurora-cliffs',
  name: 'Aurora Cliffs',
  description:
    'A dramatic northern cliffside championship course combining exposed water, forest and a fearsome finish.',
  environmentPreset: 'northern-aurora',
  metadata: {
    location: 'Cape Aurora, Newfoundland',
    regionType: 'northern ocean cliffs',
    difficulty: 89,
    typicalWind: [10, 26] as const,
    greenSpeed: [11, 12] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Distance, exposed wind, precise approaches and pressure finishing holes',
    signatureHoles: [4, 11, 15, 18],
    tournamentEventId: 'event-10',
    previewTheme: 'aurora-cliff-water',
    environmentPalette: {
      fairway: '#477264',
      rough: '#294e49',
      bunker: '#aaa791',
      water: '#264f6f',
      haze: '#88aeba',
    },
    vegetationStyle: 'wind-shaped northern spruce',
    terrainStyle: terrainPreset('cliff-escarpment', 27, 150, 1.2).id,
  },
};
const pars = [4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 5, 3, 4, 4, 3, 4, 4, 5];
const yards = [
  430, 410, 555, 185, 450, 400, 540, 175, 420, 440, 580, 165, 425, 500, 200, 460, 435, 480,
];
const names = [
  'North Light',
  'Fir Shelf',
  'Sea Reach',
  'Cliff Edge',
  'Headland',
  'Uphill Gale',
  'Aurora Run',
  'Ice Blue',
  'Forest Turn',
  'Sounding',
  'Water Gamble',
  'Far Beacon',
  'Highland',
  'Long Rise',
  'Over the Sound',
  'The Gauntlet',
  'Penultimate',
  'Northern Crown',
];
const options: Partial<HolePlan>[] = [];
options[3] = { water: 'green', elevation: { tee: 18, landing: 4, green: 0 } };
options[10] = { water: 'carry', landingZones: [{ distance: 285, width: 45 }] };
options[13] = { elevation: { tee: 0, landing: 14, green: 25 } };
options[15] = { water: 'right', bunkerCount: 4 };
options[16] = { landingZones: [{ distance: 275, width: 30 }] };
options[17] = { water: 'green', elevation: { tee: 16, landing: 3, green: 0 }, bunkerCount: 4 };
export const createAuroraCliffsDocument = () =>
  authorCourse({
    ...auroraCliffsMetadata,
    plans: plans(names, pars, yards, options).map((p) => ({ ...p, trees: p.trees ?? 5 })),
  });
